<template>
    <navBar title="Ares - Templates" :home="true" type="mltp"/>
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
    components: {
        navBar,
    },
    }
</script>  
